import PropTypes from 'prop-types';
import React from 'react';

import { GED, HS_DIPLOMA } from '@glass/common/educations/degrees';
import { EDUCATION_EXP_QUERY, TEMPLATE_VIEW_QUERY } from '@glass/common/modules/pages/queryParams';
import { EDUCATION_EXPERIENCE_SECTION_ID } from '@glass/web/modules/content/pages/contentIds';

import ExperienceSection from '@glass/shared/components/Section/ExperienceSection/ExperienceSection';
import withTrackingContext from '@glass/shared/modules/tracking/withTrackingContext';

const STATIC_EDUCATION_EXPERIENCE_OPTIONS = [
  {
    text: 'Some HS',
    params: {
      [EDUCATION_EXP_QUERY]: 'some-hs',
    },
  },
  {
    text: HS_DIPLOMA,
    params: {
      [EDUCATION_EXP_QUERY]: 'hs',
    },
  },
  {
    text: GED,
    params: {
      [EDUCATION_EXP_QUERY]: 'ged',
    },
  },
  {
    text: 'Some College',
    params: {
      [EDUCATION_EXP_QUERY]: 'some-college',
    },
  },
  {
    text: 'Bachelor',
    params: {
      [EDUCATION_EXP_QUERY]: 'bachelor',
    },
  },
  {
    text: 'Masters',
    params: {
      [EDUCATION_EXP_QUERY]: 'masters',
    },
  },
  {
    text: 'Doctorate',
    params: {
      [EDUCATION_EXP_QUERY]: 'doctorate',
    },
  },
];
const ctaQueryParams = { [TEMPLATE_VIEW_QUERY]: EDUCATION_EXP_QUERY };
const EducationExperienceSection = React.forwardRef(
  (
    {
      title,
      subtitle,
      isAlternatingColor,
      onButtonClick,
      disableCta,
      isNoXPadding,
      overflow,
      outerSpacing,
      spacing,
      type,
      persistQueryParams,
      shallow,
      titleComponent,
      titleVariant,
    },
    ref,
  ) => {
    return (
      <ExperienceSection
        ref={ref}
        ctaQueryParams={ctaQueryParams}
        ctaText="Start $(verbWords.wording) with any level"
        disableCta={disableCta}
        isAlternatingColor={isAlternatingColor}
        isNoXPadding={isNoXPadding}
        options={STATIC_EDUCATION_EXPERIENCE_OPTIONS}
        outerSpacing={outerSpacing}
        overflow={overflow}
        persistQueryParams={persistQueryParams}
        shallow={shallow}
        spacing={spacing}
        subtitle={subtitle}
        title={title}
        titleComponent={titleComponent}
        titleVariant={titleVariant}
        type={type}
        onButtonClick={onButtonClick}
      />
    );
  },
);

EducationExperienceSection.propTypes = {
  disableCta: PropTypes.bool,
  isAlternatingColor: PropTypes.bool,
  isNoXPadding: PropTypes.bool,
  onButtonClick: PropTypes.func,
  outerSpacing: PropTypes.number,
  overflow: PropTypes.string,
  persistQueryParams: PropTypes.bool,
  shallow: PropTypes.bool,
  spacing: PropTypes.number,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  titleComponent: PropTypes.string,
  titleVariant: PropTypes.string,
  type: PropTypes.string,
};

EducationExperienceSection.defaultProps = {
  title: `What's your education level?`,
  subtitle: `We'll offer recruiter validated recommendations and templates for any education level`,
  type: EDUCATION_EXPERIENCE_SECTION_ID,
};

export default React.memo(
  withTrackingContext(EducationExperienceSection, EDUCATION_EXPERIENCE_SECTION_ID),
);
